module.exports = __webpack_public_path__ + "static/nxrt-mainpage8-f52f0cce52aa1b1c2623e46b6187f05d.jpg";